export const locale = {
  lang: 'fr',
  data: {
    legalEntityPracticeV3Invoice: {
      notifications: {
        seeLegalEntityInvoice: 'Génération de la facture en cours ...'
      }
    }
  }
};
